import {EuRegistrationService} from "./service/api/eu-registration.service";
import {EuUserService} from "./service/api/eu-user.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {
    EuRegistrationObjectComponent
} from "./component/protected-components/eu-registration-object/eu-registration-object.component";
import {
    EuStaticNotificationObjectComponent
} from "./component/protected-components/eu-static-notification-object/eu-static-notification-object.component";
import {
    CrManageRegistrationUserComponent
} from "../cr/component/protected-components/cr-manage-registration/cr-manage-registration-user/cr-manage-registration-user.component";

export const EU_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['eu.EuFrontEndText', {route: '/eu/euFrontEndTexts'}],
            ['eu.EuDefaultRole', {route: '/eu/euDefaultRoles'}],
            ['eu.EuThemeColor', {route: '/eu/euThemeColors'}],
            ['eu.EuRegistration', {
                route: '/eu/euRegistrations',
                service: EuRegistrationService,
                objectComponent: [{component: EuRegistrationObjectComponent}],
                objectPageComponent: CrManageRegistrationUserComponent,
            }],
            ['eu.EuUserAddedInsurance', {route: '/eu/euUserAddedInsurances'}],
            ['eu.EuRole', {route: '/eu/euRoles'}],
            ['eu.EuUserRelatedPersonImage', {route: '/eu/euUserRelatedPersonImages'}],
            ['eu.EuUserTest', {route: '/eu/euUserTests'}],
            ['eu.EuOtpCode', {route: '/eu/euOtpCodes'}],
            ['eu.EuFrontEndThemeColorDto', {route: null}],
            ['eu.EuStaticNotificationContractPersonType', {route: '/eu/euStaticNotificationContractPersonTypes'}],
            ['eu.EuUserRole', {route: '/eu/euUserRoles'}],
            ['eu.EuUser', {route: '/eu/euUsers', service: EuUserService}],
            ['eu.EuPasswordResetToken', {route: '/eu/euPasswordResetTokens'}],
            ['eu.EuPartner', {route: '/eu/euPartners'}],
            ['eu.EuTmConfiguration', {route: '/eu/euTmConfigurations'}],
            ['eu.EuPromotion', {route: '/eu/euPromotions'}],
            ['eu.EuUserObjectAccess', {route: '/eu/euUserObjectAccesss'}],
            ['eu.EuStaticNotification', {
                route: '/eu/euStaticNotifications',
                objectComponent: [{component: EuStaticNotificationObjectComponent}],
            }],
            ['eu.EuRegistrationSignature', {route: '/eu/euRegistrationSignatures'}],
            ['eu.EuUserAddedInsuranceDocument', {route: '/eu/euUserAddedInsuranceDocuments'}],
            ['eu.EuStaticNotificationContractType', {route: '/eu/euStaticNotificationContractTypes'}],
            ['eu.EuUserInsurableObjectImage', {route: '/eu/euUserInsurableObjectImages'}],
            ['eu.EuUserDevice', {route: '/eu/euUserDevices'}],
            ['eu.EuStaticNotificationInsurableObjectType', {route: '/eu/euStaticNotificationInsurableObjectTypes'}],
            ['eu.EuNotificationType', {route: '/eu/euNotificationTypes'}],
            ['eu.EuUserDocumentType', {route: '/eu/euUserDocumentTypes'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
